import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '@/components/home'
import price from '@/components/price'
import demo from '@/components/demo'
import func from '@/components/function'
import about from '@/components/about'
import login from '@/components/sign_in'
import reg from '@/components/sign_up'
import pwdChg from '@/components/pwdChg'
import index from '@/components/index'
import message from '@/components/message'
import terms from '@/components/terms'
import privacy from '@/components/privacy'

import setting from '@/components/setting/setting'
import myInfo from '@/components/setting/info'
import invoice from '@/components/setting/invoice'
import changePwd from '@/components/setting/changePwd'
import order from '@/components/setting/order'
import queryLog from '@/components/setting/queryLog'
import invoiceDetail from '@/components/setting/invoiceDetail'
import invoiceApply from '@/components/setting/invoiceApply'
import linkedInDetail from '@/components/setting/linkedInDetail'


import customs from '@/components/customs/customsHome'
import customsIndex from '@/components/customs/customsIndex'
import customsSearch from '@/components/customs/customs'
import emailSearch from '@/components/customs/emailSearch'
import gdSearch from '@/components/customs/gdSearch'
import customsReport from '@/components/customs/customsReport'
import payment from '@/components/customs/payment'
import donation from '@/components/customs/donation'
import wxPay from '@/components/customs/wxPay'
import emailCheck from '@/components/customs/emailCheck'
import hsCode from '@/components/customs/hsCode'
import linkedIn from '@/components/customs/peopleSearch'
import customsContact from '@/components/customs/customsContact'
import feature from '@/components/customs/feature'
import chatGPT from '@/components/customs/chatGPT'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
	  redirect: '/customs/index'
    },
	

    {
      path: '/terms',
      name: 'terms',
      component: terms
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },	
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy
    },

	{
      path: '/customs', 
      component: customs,
	  children: [ 			
		{
		  path: '/customs/index',
		  name: 'customsIndex',
		  component: customsIndex,	
		},
		{
		  path: '/customs/emailCheck',
		  name: 'emailCheck',
		  component: emailCheck,	
		},
		{
		  path: '/customs/linkedIn',
		  name: 'linkedIn',
		  component: linkedIn,	
		},		
		{
		  path: '/customs/customsSearch',
		  name: 'customsSearch',
		  component: customsSearch 	
		},
		{
		  path: '/customs/customsReport',
		  name: 'customsReport',
		  component: customsReport  	
		},		
		{
		  path: '/customs/emailSearch',
		  name: 'emailSearch',
		  component: emailSearch	
		},
		{
		  path: '/customs/hsCode',
		  name: 'hsCode',
		  component: hsCode	
		},		
		{
		  path: '/customs/gdSearch',
		  name: 'gdSearch',
		  component: gdSearch	
		},
		{
		  path: '/customs/payment',
		  name: 'payment',
		  component: payment	
		},	
		{
		  path: '/customs/donation',
		  name: 'donation',
		  component: donation	
		},	
		{
		  path: '/customs/wxpay',
		  name: 'wxpay',
		  component: wxPay	
		},		
		{
		  path: '/customs/customsContact',
		  name: 'customsContact',
		  component: customsContact	
		},
		{
		  path: '/customs/feature',
		  name: 'feature',
		  component: feature	
		},	
		{
		  path: '/customs/chatGPT',
		  name: 'chatGPT',
		  component: chatGPT	
		},	
        {
          path: '/login',
          name: 'login',
          component: login
        },
        {
          path: '/reg',
          name: 'reg',
          component: reg
        },		
	  ]
	},
    {
      path: '/home', 
      component: home,
	  children: [ 			
		{
		  path: '/home/index',
		  name: 'index',
		  component: index,	
		},
		{
		  path: '/home/price',
		  name: 'price',
		  component: price	
		},	
		{
		  path: '/home/demo',
		  name: 'demo',
		  component: demo	
		},
		{
		  path: '/home/func',
		  name: 'func',
		  component: func	
		},
		{
		  path: '/home/about',
		  name: 'about',
		  component: about	
		},
        {
          path: '/pwdChg',
          name: 'pwdChg',
          component: pwdChg
        },		
	  ]
	},
    {
      path: '/setting',
      //redirect: '/myInfo',
      component: setting,
	  children: [ 			
		{
		  path: '/setting/myInfo',
		  name: 'myInfo',
		  component: myInfo,	
		},
		{
		  path: '/setting/invoice',
		  name: 'invoice',
		  component: invoice	
		},	
		{
		  path: '/setting/invoiceApply',
		  name: 'invoiceApply',
		  component: invoiceApply	
		},	
		{
		  path: '/setting/invoiceDetail',
		  name: 'invoiceDetail',
		  component: invoiceDetail	
		},			
		{
		  path: '/setting/order',
		  name: 'order',
		  component: order	
		},
		{
		  path: '/setting/changePwd',
		  name: 'changePwd',
		  component: changePwd	
		},
		{
		  path: '/setting/queryLog',
		  name: 'queryLog',
		  component: queryLog	
		},	
		
		{
		  path: '/setting/linkedInDetail',
		  name: 'linkedInDetail',
		  component:  linkedInDetail	
		},			
	  ]
	},
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js